<div class="head-count">
    <div class="styled-container">
      <div class="row-container">
        <div class="col">
          <emerald-card >
            <div class="content-container">
              <div class="header-row">
                <div class="heading-title">Interview Status</div>
                <div class="filter">
                  <emerald-dropdown
                  [options]="monthOptions" 
                  [outlined]="true"
                  [id]="'single_select'"
                  [label]="'Month'"
                  (onChange)="onMonthChange($event)"
                ></emerald-dropdown>
                </div>
              </div>
            </div>
            
            <div class="metrics">
              <div class="metric">
                <span class="label">Positions Opened</span>
                <span class="value">{{ data?.positionsOpened  || '0'}}</span>
              </div>
              <div class="metric">
                <span class="label">Profiles Submitted</span>
                <span class="value">{{ data?.profilesSubmitted  || '0'}}</span>
              </div>
              <div class="metric">
                <span class="label">Onboard Pending</span>
                <span class="value">{{ data?.onBoardingPending  || '0'}}</span>
              </div>
              <div class="metric">
                <span class="label">In Progress </span>
                <span class="value">{{ data?.inProgress || '0' }}</span>
              </div>
            </div>
          </emerald-card>
        </div>
      </div>
    </div>
  </div>